export const NAV = {
  logo: 'nav-logo',
  home: 'nav-home-link',
  feed: 'nav-feed-link',
  guidelines: 'nav-guidelines-link',
  getSupport: 'nav-get-support-link',
  framework: 'nav-framework-link',
  bern: 'nav-bern-link',
  greenbook: 'nav-greenbook-link',
  donate: 'nav-donate-link',
  merch: 'nav-merch-link',
  login: 'nav-login-link',
  register: 'nav-register-link',
  dashboard: 'nav-dashboard-link',
  userMenu: 'nav-user-menu-button',
  mobileMenuToggle: 'nav-mobile-menu-toggle',
};
